import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { PRIVACY_POST } from './content';

export default function PrivacyPage() {
  return (
    <div className="page page-narrow">
      <p className="section-label">nk4i.com</p>
      <h1 className="section-title">Privacy Policy</h1>
      <div className="section-divider" />

      <div className="article-content">
        {PRIVACY_POST ? (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {PRIVACY_POST.content}
          </ReactMarkdown>
        ) : (
          <p>The privacy policy is currently unavailable.</p>
        )}
      </div>
    </div>
  );
}
